import styled from 'styled-components';

import { manageColor } from '@pb/styles';
import {
    TFontWeights,
    TManageFontProperties,
    TManageFontReturnValues,
    TStyledHeadingProperties,
} from './heading.types';

const manageFont = ({
    headingSize,
    screenSize,
}: TManageFontProperties): TManageFontReturnValues => {
    let fontAttributes: TManageFontReturnValues;

    const sizes = {
        alpha: {
            size: '6.4rem',
            lineHeight: 72 / 64,
            letterSpacing: '-0.5px',
        },
        beta: {
            size: '5.4rem',
            lineHeight: 60 / 54,
            letterSpacing: '-0.44px',
        },
        gamma: {
            size: '4.8rem',
            lineHeight: 56 / 48,
            letterSpacing: '-0.39px',
        },
        delta: {
            size: '4.2rem',
            lineHeight: 48 / 42,
            letterSpacing: '-0.34px',
        },
        epsilon: {
            size: '3.6rem',
            lineHeight: 44 / 36,
            letterSpacing: '-0.28px',
        },
        zeta: {
            size: '3.2rem',
            lineHeight: 40 / 32,
            letterSpacing: '-0.22px',
        },
        eta: { size: '2.8rem', lineHeight: 36 / 28, letterSpacing: '-0.17px' },
        theta: {
            size: '2.4rem',
            lineHeight: 32 / 24,
            letterSpacing: '-0.12px',
        },
        iota: {
            size: '2.1rem',
            lineHeight: 28 / 21,
            letterSpacing: '-0.06px',
        },
        kappa: { size: '1.8rem', lineHeight: 24 / 18, letterSpacing: '0' },
        lambda: {
            size: '1.6rem',
            lineHeight: 20 / 16,
            letterSpacing: '0.05px',
        },
        mu: { size: '1.4rem', lineHeight: 20 / 14, letterSpacing: '0' },
    };

    switch (headingSize) {
        case 'xlarge':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.epsilon;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.beta;
            } else {
                fontAttributes = sizes.alpha;
            }
            break;

        case 'large':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.eta;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.delta;
            } else {
                fontAttributes = sizes.gamma;
            }
            break;

        case 'medium':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.theta;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.zeta;
            } else {
                fontAttributes = sizes.epsilon;
            }
            break;

        case 'small':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.iota;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.theta;
            } else {
                fontAttributes = sizes.eta;
            }
            break;

        case 'xsmall':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.kappa;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.kappa;
            } else {
                fontAttributes = sizes.iota;
            }
            break;

        case 'xxsmall':
            if (screenSize === 'mobile') {
                fontAttributes = sizes.lambda;
            } else if (screenSize === 'tablet') {
                fontAttributes = sizes.lambda;
            } else {
                fontAttributes = sizes.kappa;
            }
            break;
    }

    return fontAttributes;
};

export const StyledHeading = styled.p<TStyledHeadingProperties>`
    margin-top: ${({ marginTop }) => (marginTop === 'none' ? '0' : '1.6rem')};
    margin-right: 0;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom === 'none' ? '0' : '1.6rem'};
    margin-left: 0;
    color: ${({ textColor, theme }) =>
        manageColor({ color: textColor, theme })};
    font-weight: ${({ theme, weight }) =>
        theme.font.weight[weight as TFontWeights]};
    font-size: ${({ size }) => manageFont({ headingSize: size }).size};
    font-family: ${properties => properties.theme.font.family.secondary};
    line-height: ${({ size }) => manageFont({ headingSize: size }).lineHeight};
    letter-spacing: ${({ size }) =>
        manageFont({ headingSize: size }).letterSpacing};
    text-align: ${({ align }) => align};

    @media (max-width: ${properties => properties.theme.breakpoints.m.max}) {
        font-size: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'tablet',
            }).size};
        line-height: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'tablet',
            }).lineHeight};
        letter-spacing: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'tablet',
            }).letterSpacing};
    }

    @media (max-width: ${properties => properties.theme.breakpoints.xs.max}) {
        font-size: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'mobile',
            }).size};
        line-height: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'mobile',
            }).lineHeight};
        letter-spacing: ${({ size }) =>
            manageFont({
                headingSize: size,
                screenSize: 'mobile',
            }).letterSpacing};
    }
`;
